export enum GeneralOverviewType {
    OTC_DRUG = 'OTC_DRUG',
    NON_PRESCRIPTION_DRUGS_NOT_SUBJECT_TO_TESTING = 'NON_PRESCRIPTION_DRUGS_NOT_SUBJECT_TO_TESTING',
    PRESCRIPTION_DRUG_LIST = 'PRESCRIPTION_DRUG_LIST',
    ETHICAL_DRUG = 'ETHICAL_DRUG',
    VETERINARY_DRUG = 'VETERINARY_DRUG',
    SCHEDULE_C_RADIOPHARMACEUTICAL = 'SCHEDULE_C_RADIOPHARMACEUTICAL',
    SCHEDULE_D_BIOLOGIC_VACCINE = 'SCHEDULE_D_BIOLOGIC_VACCINE',
    DISINFECTANT_DRUG = 'DISINFECTANT_DRUG',
    SPECIAL_ACCESS_PROGRAM = 'SPECIAL_ACCESS_PROGRAM',
    NATURAL_HEALTH_PRODUCT = 'NATURAL_HEALTH_PRODUCT',
    MEDICAL_DEVICE = 'MEDICAL_DEVICE',
    NARCOTICS = 'NARCOTICS',
    CONTROLLED_DRUG = 'CONTROLLED_DRUG',
    PRECURSOR = 'PRECURSOR',
}
